// The photos attached to an item's tasks, for the strip under each task row.
//
// Four lines over useFleetEntryPhotos, because the two prefixes have the same
// shape: attachments are keyed `${itemId}/task/${taskId}/<file>`
// (Urls.urlForTaskStorage), so ONE listing of `${itemId}/task/` carries every
// task's photos and the grouping is a path segment -- exactly what the logbook
// hook does one folder-name over. Everything that file's header says applies
// here unchanged: one read for the whole page, a map immune to the row list
// changing (which matters more here, because the task tables page in through
// infinite scroll), `null` until answered, and the switch is the retry.
//
// The returned Map is keyed by TASK id. The name `photosByEntry` is the shared
// hook's; a caller here reads it as "photos by row".

import { useFleetEntryPhotos } from '../logbook/useEntryPhotos';
import { urlForTaskStorageRoot } from '../../fleet-shared/Urls.mjs';

export function useTaskPhotos(itemId, { enabled } = {}) {
  return useFleetEntryPhotos(itemId ? [itemId] : [], {
    enabled,
    storageRoot: urlForTaskStorageRoot,
  });
}

export default useTaskPhotos;
